import $ from 'jquery';
import Swiper from 'swiper';
import Cookies from 'js-cookie'
import AOS from 'aos';
import { Navigation, Controller } from 'swiper/modules';
import 'core-js';

window.Swiper = Swiper;
window.$ = $;
window.Cookies = Cookies;


$(function () {
  if (Cookies.get('consent') === undefined) {
    $('#agreeCookie').find('.agree-cookie-btn').on('click', function () {
      $('#agreeCookie').addClass('approved');
      Cookies.set('consent', 'true');
    });
  } else {
    $('#agreeCookie').remove();
  }
  //scroll top
  $('#back_to_top').click(function (event) {
    $("html,body").animate({ scrollTop: 0 }, 1000);
  });

  // scroll header
  function headerScroll() {
    if ($(window).scrollTop() > 100) {
      $('.header').addClass("min-header");
      $('#back_to_top').addClass("is-active");
    } else {
      $('.header').removeClass("min-header");
      $('#back_to_top').removeClass("is-active");
    }
  }
  headerScroll();
  $(window).on('scroll', function () {
    headerScroll();
  });

  $('.header-mobile-menu').on('click', function () {
    $('.header-menu-outer').addClass('is-active');
  });

  $('.header-menu-close, .header-menu-mask').on('click', function () {
    $('.header-menu-outer').addClass('is-hide');
    setTimeout(() => {
      $('.header-menu-outer').removeClass('is-active is-hide');
    }, 300);
  });

  $('.menu-link').click(function (e) {
    if (window.innerWidth <= 1024) {
      e.preventdefault;
      $(this).parent('.header-menu-link').toggleClass('is-active');
    }else {
      $(this).parent('.header-menu-link').toggleClass('is-active');
    }
  });

  // dropdown
  $('.dropdown-btn').on('click', function () {
    const id = $(this).attr('id');
    const dropdown_is_active = $('[aria-labelledby=' + id + ']').hasClass("is-active");
    if (dropdown_is_active >= 1) {
      $(this).removeClass('is-active');
      $('[aria-labelledby=' + id + ']').removeClass('is-active');
      if (window.innerWidth <= 640) {
        $('body').css({
          'height': '',
          'overflow': '',
        })
      }
    } else {
      $(this).addClass('is-active');
      $(".dropdown-list:not([aria-labelledby=" + id + "]").removeClass('is-active');
      $('[aria-labelledby=' + id + ']').addClass('is-active');
      if (window.innerWidth <= 640) {
        $('body').css({
          'height': '100vh',
          'overflow': 'hidden',
        })
      }
    }
  });

  // 手機版變成下拉選單
  $('.mobile-dropdown-btn').on('click', function () {
    const id = $(this).attr('id');
    const dropdown_is_active = $('[aria-labelledby=' + id + ']').hasClass("is-active");
    if (dropdown_is_active >= 1) {
      $(this).removeClass('is-active');
      $('[aria-labelledby=' + id + ']').removeClass('is-active');
      $('body').css({
        'height': '',
        'overflow': '',
      })
    } else {
      $(this).addClass('is-active');
      $(".mobile-dropdown-list:not([aria-labelledby=" + id + "]").removeClass('is-active');
      $('[aria-labelledby=' + id + ']').addClass('is-active');
      $('body').css({
        'height': '100vh',
        'overflow': 'hidden',
      })
    }
  });
  $(document).click(function (event) {
    if (!$(event.target).closest('.dropdown-btn').length) {
      if (!$(event.target).closest('.group-opts').length) {
        if ($('.dropdown-list').is(":visible")) {
          $('.dropdown-btn').removeClass('is-active');
          $(".dropdown-list").removeClass('is-active');
          if (window.innerWidth <= 640) {
            $('body').css({
              'height': '',
              'overflow': '',
            })
          }
        }
      }
    }
    if (!$(event.target).closest('.mobile-dropdown-btn').length) {
      if ($('.mobile-dropdown-list').is(":visible")) {
        $('.mobile-dropdown-btn').removeClass('is-active');
        $(".mobile-dropdown-list").removeClass('is-active');
        $('body').css({
          'height': '',
          'overflow': '',
        })
      }
    }
  });

  var indexFeedbackSwiper = new Swiper('#indexFeedbackSwiper', {
    modules: [Navigation,Controller],
    slidesPerView: 1.5,
    slidesOffsetBefore: 25,
    slidesOffsetAfter: 50,
    navigation: {
      prevEl: "#index-feedback-prev",
      nextEl: "#index-feedback-next",
    },
    breakpoints: {
      640: {
        slidesPerView: 2.5,
        slidesOffsetBefore: 0,
      },
      1000: {
        slidesPerView: 3.5,
        slidesOffsetBefore: 0,
      },
      1360: {
        slidesPerView: 2.8,
        slidesOffsetBefore: 0,
      },
      1600: {
        slidesPerView: 3.5,
        slidesOffsetBefore: 0,
      },
      2100: {
        slidesPerView: 4,
        slidesOffsetBefore: 0,
      }
    }
  });

  var otherProducts = new Swiper('#otherProducts', {
    modules: [Navigation],
    slidesPerView: 1.5,
    navigation: {
      prevEl: ".swiper-btn-prev",
      nextEl: ".swiper-btn-next",
    },
    breakpoints: {
      0: {
        slidesPerView: 1.3,
        slidesOffsetBefore: 30,
        slidesOffsetAfter: 30,
        spaceBetween: 10,
      },
      640: {
        slidesPerView: 2,
        spaceBetween: 23,
      },
      1000: {
        slidesPerView: 3,
        spaceBetween: 25,
      },
    }
  });

  // tab
  $('.tab[data-tab]').on('click', function () {
    var tabPanes = $(this).data('tabs');
    var ID = $(this).data('tab');
    $(this).addClass('is-active').siblings().removeClass('is-active');
    $("[data-tab-panes=" + tabPanes + "]").find("[data-tab-pane=" + ID + "]").addClass('is-active').siblings().removeClass('is-active');
  });

  $('.faqs-menu-item').on('click', function() {
    const menuName = $(this).html();
    $('#faqs_btn').html(menuName);
  });

  AOS.init();
});
